<script>
	export default {
		props: ['cod', 'label', 'pInit', 'pTerm', 'rInit', 'rTerm'],
	};
</script>



// WEBPACK FOOTER //
// src/components/order-of-service/components/GraficMode/components/item-os.vue